import storeModule from '../../store-module'
import { defineStore } from 'pinia'

const url = 'dashboard/brokers-performance'

export default defineStore(
  'dashboard-brokers-performance',
  storeModule.createStoreModule('dashboard-brokers-performance', {
    fetchListURL: url,
    fetchFiltersURL: `${url}/filters`
  })
)
